import React from 'react'
import PropTypes from 'prop-types'
import {Button, ButtonGroup} from 'reactstrap'
// import parseGGDriver from '../../helpers/parseGGDriver'
import parseGGDriver from './parseGGDriver'

class ViewImageItem extends React.Component {
    state = {
        error: false,
        isBlack: true
    }

    _handleLoadImageError = () => {
        console.log("Loading image error:", this.props.designKey)

        this.setState({
            error: true
        })
    }

    _handleClickSyncDesign = e => {
        e.preventDefault()

        this.setState({
            error: false
        }, () => {
            const {designKey} = this.props
            this.props.onSync(designKey)
        })
    }

    _changeBackground = (value) => {
        this.setState({
            isBlack: value
        })
    }


    render() {
        const {title, mockUp, design, designKey, designSleeve} = this.props
        const {error, isBlack} = this.state
        const designLink= parseGGDriver(design||"")
        const mockUpLink= parseGGDriver(mockUp||"")

        return (
            <div className='ViewImageItem'>
                <div className='text-center Heading'>
                    <h2>{title}</h2>
                </div>
                <div className="BodyImage">
                    <div className="ImageList">
                        <div className="MockupImage">
                            <h3>Mock up</h3>

                            <div className="ImageContent">
                                {
                                    mockUp ?
                                        <img alt={title} src={mockUpLink}/> :
                                        <div className='Image'>300x400</div>
                                }
                            </div>
                        </div>
                        <div className="DesignImage">
                            <h3>Design</h3>
                            {
                                !!error &&
                                <button
                                    onClick={this._handleClickSyncDesign}
                                    className="btn btn-info"
                                >
                                    Sync design
                                </button>
                            }
                            <div className="ImageContent">
                                {
                                    design ?
                                        <img
                                            className={isBlack ? 'Black' : 'White'}
                                            onError={this._handleLoadImageError}
                                            alt={designKey} src={designLink}
                                        /> :
                                        <div className='Image'>300x400</div>
                                }
                            </div>

                            <ButtonGroup className='mt-3 mb-3 ColorCustom'>
                                <Button onClick={() => this._changeBackground(false)} active={!isBlack}>
                                    Nền Trắng
                                </Button>
                                <Button onClick={() => this._changeBackground(true)} active={isBlack}>
                                    Nền đen
                                </Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

ViewImageItem.propTypes = {
    title: PropTypes.string,
    mockUp: PropTypes.string,
    design: PropTypes.string,
    designKey: PropTypes.string,
    onSync: PropTypes.func,
}

export default ViewImageItem
